import { useMutation } from "@tanstack/react-query";
import type { UseMutationOptions } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import type { AssessmentSubmissionParams, AssessmentSubmissionResponse, UUID } from "@/core/types";
import { showToast } from "@/providers/ToastProvider";
import { removeTaskFromProfile } from "@/redux/actions/auth";

import { postAnswer } from "../queryFunctions/postAnswer";

type UseSubmitAssessmentOptions = {
  taskId: UUID;
} & UseMutationOptions<AssessmentSubmissionResponse, unknown, AssessmentSubmissionParams>;

export function useSubmitAssessment(options: UseSubmitAssessmentOptions) {
  const dispatch = useDispatch();
  const history = useHistory();

  return useMutation({
    mutationFn: postAnswer,
    onSuccess: async () => {
      // Optimistically remove task from profile
      dispatch(removeTaskFromProfile(options.taskId));

      showToast([
        {
          heading: "Social Needs Check-In complete.",
          text: "Your care team will review your answers.",
          variant: "success",
        },
      ]);

      history.push("/app/home");
    },
    ...options,
  });
}
